export default __webpack_public_path__ + "static/media/a_experience_accuracy.e168f4af.png";